import Vue from 'vue';
import BzbsApi from '@/core/Http/BzbsApi.js';

/**
 * @method apiGetPDPAVersion
 * @method apiGetPDPAContent
 */

export default {
     config: function () {
        return Vue.bzbsConfig;
     },
     /**
      * Return PDPA version
      */
     apiGetPDPAVersion: function () {
        var appId = this.config().client_id;
        var url = `${this.config().bzbsBlobUrl}/pdpaconsent/${appId}/version`;
        return BzbsApi.connectBzbsGetBlob(url);
     },
     /**
      * Return PDPA contents.
      * @param {String} contentType Terms, privacy, etc..
      * @param {Number} version PDPA content version
      * @param {Number} language PDPA language code.
      */
     apiGetPDPAContent: function (contentType, theme, version, language) {
        var appId = this.config().client_id;
        var url = `${this.config().bzbsBlobUrl}/pdpaconsent/${appId}/${contentType}/${theme}/${version}/${language}`;
        return BzbsApi.connectBzbsGetBlob(url);
     },

     /**
      * @param {string} token
      * @param {number|string} termandcondition
      * @param {number|string} dataprivacy
      */
     apiPostConsent: function(token, termandcondition, dataprivacy) {
        var params = {
            termandcondition: termandcondition,
            dataprivacy: dataprivacy,
        };
        var url = this.config().bzbsUrl + '/consent';
        return BzbsApi.connectBzbsPost(url, token, params);
    }
}
